import {
  Button,
  Colors,
  Cross,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'

import styles from './style.module.scss'

interface IState {}

interface IProps {
  open: boolean
  onClose: () => void
}

export class AddChildWarnModal extends React.Component<IProps, IState> {
  setActive = (status: boolean) => {
    const { onClose } = this.props
    if (!status) {
      onClose()
    }
  }

  render() {
    const { open, onClose } = this.props

    return (
      <Modal
        active={open}
        setActive={this.setActive}
        baseClassName={styles.wrap}
        x={<Cross size="big" color={Colors.unselected} />}
      >
        <Typography type="title" size="big">
          Before you begin
        </Typography>
        <Typography type="text">
          GiantLeap is best suited for children <b>between 4-8 years old.</b>
        </Typography>

        <Typography type="text">
          We advise to <b>wait until your child is better prepared</b> for the
          evaluation process, as it tends to be difficult for younger children.
        </Typography>

        <Button
          onClick={() => {
            onClose()
          }}
          type="max"
          color="purple"
        >
          Got it
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/AddChild/WarnModal/addChildWarnModal.tsx